import { useCallback, useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import useAppSelector from "@/core/helpers/useAppSelector";
import { ValidateCode } from "@/shared/ui";
import { safetySelector } from "@/domains/account/slice";
import useGetCodeTimer from "@/domains/playerMenu/hooks/useGetCodeTimer";
import useSmsCode from "@/domains/playerMenu/hooks/useSmsCode";
import useGameSettings from "@/domains/settings/hooks/useGameSettings";

type Props = {
  onClose: () => void;
};
export default function PlayerMenuSettingsSafetyDisableTfaSMSCheckContainer({ onClose }: Props) {
  const { getGameSettings } = useGameSettings();
  const { phoneNumber } = useAppSelector(safetySelector);
  const [code, setCode] = useState<string>("");
  const {
    sendCodeHandler,
    sendIsPending,
    sendError,
    checkCodeHandler,
    checkIsPending,
    checkError,
    checkIsCompleted,
  } = useSmsCode();

  const { getTimer, timer } = useGetCodeTimer();

  useEffect(() => {
    (async () => {
      if (phoneNumber) {
        await sendCodeHandler(phoneNumber, false);
        await getTimer({ type: "sms", payload: phoneNumber });
      }
    })();
  }, [phoneNumber]);

  const onSubmit = useCallback(async () => {
    checkCodeHandler(code, false);
  }, [code]);

  const onSendCodeHandler = useCallback(() => {
    sendCodeHandler(phoneNumber, false);
  }, [phoneNumber]);

  useEffect(() => {
    if (checkIsCompleted) {
      getGameSettings();
      onClose();
    }
  }, [checkIsCompleted, onClose]);

  return (
    <FocusLock className="grow flex flex-col w-full h-full">
      <ValidateCode
        address={`+7${phoneNumber}`}
        type={TfaMethod.SMS}
        code={code}
        onCodeChange={setCode}
        onSubmit={onSubmit}
        onSendCode={onSendCodeHandler}
        pending={checkIsPending}
        error={checkError || sendError}
        sendCodePending={sendIsPending}
        timer={timer}
      />
    </FocusLock>
  );
}
